import { createContext, useContext, useState } from "react";
import React from "react"; // Ensure React is imported for JSX usage
import { useSearchParams } from "react-router-dom";

interface ConfigContextType {
  isWebView?: boolean;
}

// 기본값 설정
const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const ConfigProvider = ({ children }: { children: React.ReactNode }) => {
  let [searchParams] = useSearchParams();

  const isBottomSheet = searchParams.get("isBottomSheet");
  const [isWebView] = useState(isBottomSheet === "false");

  return (
    <ConfigContext.Provider value={{ isWebView }}>
      {children}
    </ConfigContext.Provider>
  );
};

// 커스텀 훅
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context)
    throw new Error("useConfig must be used within a ConfigProvider");
  return context;
};
